import {
  ChevronUp,
  // Edit,
  Filter,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import Select from "react-select";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import withReactContent from "sweetalert2-react-content";
// import Swal from "sweetalert2";
import { all_routes } from "../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import Axios from "axios";
import { API_BASE_URL, GET_COMBO_PRODUCTS } from "../../Config";
// import useOnlineStatus from '../../userOnlineStatus';
// import OnlineImg from './online.jpg';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AddComboProduct from "./../../core/modals/inventory/addcomboproduct";
import { setcomboproductlist_data } from "../../core/redux/action";
import ViewComboProduct from "../../core/modals/inventory/viewcomboproducts";
import { getUserPermissions } from "../../UserPermissions";
import SpinLoader from "../loader/SpinLoader";

const ComboProducts = () => {
  // const isOnline = useOnlineStatus();
  const [userDataSession, setUserDataSession] = useState([]);
  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.comboproduct_list) || [];
  const [searchQuery, setSearchQuery] = useState("");
  const data = useSelector((state) => state.toggle_header);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [viewDataObj, setViewDataObj] = useState([]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    // const categoryData = JSON.parse(sessionStorage.getItem('filteredDDLData_CATEGORY'));

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      // setCategoryData(categoryData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_COMBO_PRODUCTS}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data) {
            dispatch(setcomboproductlist_data(response.data.ResultData));
            setLoading(false);
          } else {
            setLoading(false);
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching data:", error);
        });
    }
  }, [dispatch, userDataSession]);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Combo Products/Services");
    setPermissions(perms);
  }, []);

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.ParentProductName &&
        item.ParentProductName.toLowerCase().includes(
          searchQuery.toLowerCase()
        )) ||
      (item.ChildProductName &&
        item.ChildProductName.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const route = all_routes;

  const showViewModal = (record) => {
    setViewDataObj(record);
  };

  const columns = [
    {
      title: "Combo Product",
      dataIndex: "ParentProductName",
      sorter: (a, b) => a.ParentProductName.length - b.ParentProductName.length,
    },

    {
      title: "Quantity",
      dataIndex: "TotalQuantity",
      sorter: (a, b) => a.TotalQuantity.length - b.TotalQuantity.length,
    },

    {
      title: "No of Items",
      dataIndex: "TotalChildProducts",
      sorter: (a, b) => a.TotalChildProducts.length - b.TotalChildProducts.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            {/* <Link 
                className="me-2 p-2" 
                to=""
              >
                <Edit className="feather-edit" />
              </Link> */}
            <dutton
              className={`p-2 me-3 btn border rounded ${permissions.isRead}`}
              data-bs-toggle="modal"
              data-bs-target="#view-combo-product"
              onClick={() => showViewModal(record)}

            >
              <i className="fa-regular fa-eye"></i>
            </dutton>
            {/* <button
              className={`confirm-text btn border rounded p-2 ${permissions.isDelete}`}
              onClick={showConfirmationAlert}
            >
              <i className="fa-regular fa-trash-can text-danger fs-6"></i>
            </button> */}
          </div>
        </td>
      ),
    },
  ];

  // const MySwal = withReactContent(Swal);

  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         className: "btn btn-success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //     } else {
  //       MySwal.close();
  //     }
  //   });
  // };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  // const renderPrinterTooltip = (props) => (
  //   <Tooltip id="printer-tooltip" {...props}>
  //     Printer
  //   </Tooltip>
  // );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource.map((item) => ({
      "Parent Product": item.ParentProductName,
      "Child Product": item.ChildProductName,
      Quantity: item.Quantity,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "ComboProductsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "ComboProductsData.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Parent Product", "Child Product", "Quantity"];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(item.ParentProductName, item.ChildProductName, item.Quantity);
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("ComboProductsData.pdf");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Combo Products - Services</h4>
              <h6>Manage your products</h6>
            </div>
          </div>
          <ul className={`table-top-head`}>
            <li className={`${permissions.isExport}`}>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={generatePDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li className={`${permissions.isExport}`}>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={handleDownloadExcel}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            {/* <li>
                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li> */}
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className={`page-btn ${permissions.isWrite}`}>
            <Link
              to={route.addproduct}
              className="btn btn-added"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightAddComboProd"
              aria-controls="offcanvasRightAddComboProd"
            >
              <PlusCircle className="me-2 iconsize" />
              Add Combo Product
            </Link>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
            </div>

            <div className="table-responsive">
              {loading ? (

                <SpinLoader/>
                // <div className="loader m-auto"></div>
              ) : (
                <Table columns={columns} dataSource={filteredData} />
              )}
            </div>
          </div>
        </div>
        {/* /product list */}
        {/* <Brand /> */}
        <AddComboProduct />
        <ViewComboProduct viewObj={viewDataObj} />
      </div>
    </div>
  );
};

export default ComboProducts;
